import {
  Component,
  Input,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  ServiceCodeGroupType,
  type IServiceCodeGroup,
} from '@principle-theorem/principle-core/interfaces';

const descriptionMap: Map<ServiceCodeGroupType, string> = new Map([
  [
    ServiceCodeGroupType.Required,
    `Added automatically when this treatment is charted`,
  ],
  [
    ServiceCodeGroupType.Exclusive,
    `The clinician picks one of these when charting`,
  ],
  [
    ServiceCodeGroupType.Optional,
    `Suggested to the clinician to add when charting`,
  ],
]);

@Component({
  selector: 'pr-service-group-header',
  templateUrl: './service-group-header.component.html',
  styleUrls: ['./service-group-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ServiceGroupHeaderComponent {
  groupTypes: ServiceCodeGroupType[] = Array.from(descriptionMap.keys());
  @Input() group: IServiceCodeGroup;
  @Output()
  groupChange = new EventEmitter<IServiceCodeGroup>();
  @Output() deleted: EventEmitter<void> = new EventEmitter<void>();

  changeType(type: ServiceCodeGroupType): void {
    this.group.type = type;
    this.groupChange.emit(this.group);
  }

  get description(): string {
    return descriptionMap.get(this.group.type) || '';
  }
}
